import m from "../../geodata/es2015/qatarLow";
window.am4geodata_qatarLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/qatarLow.js
// module id = null
// module chunks = 